/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { Logger } from '@app/core';
import { Facility } from '@app/settings/facilities/facilities.model';
import { FacilitiesService } from '@app/settings/facilities/facilities.service';
import { FacilitiesFormService } from '@app/settings/facilities/facilities-form.service';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { environment } from '@env/environment';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { AccessService } from '@app/core/access/access.service';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';

const log = new Logger('facilitiesListComponent');

@Component({
  selector: 'app-facilities-list',
  templateUrl: './facilities-list.component.html',
  styleUrls: ['./facilities-list.component.scss'],
})
export class FacilitiesListComponent extends KendoGridComponent implements OnInit {
  facilitiesResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  env = environment;
  UserRoleType = UserRoleType;

  constructor(
    private facilityService: FacilitiesService,
    private facilitiesFormService: FacilitiesFormService,
    protected kendoGridService: KendoGridService,
    public accessService: AccessService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.state = CustomKendoFilter.getStateFromStorage('FacilitiesListComponent');
    this.loadData(this.state);
  }

  /**
   * Load data from API
   */
  loadData(state: DataStateChangeEvent = null) {
    this.state = state;
    this.apiQuery.setDataSetFilters(state);
    log.debug(this.facilityService);

    this.facilityService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.facilitiesResponse = response;
      this.data = response.getGridData();
    });
    CustomKendoFilter.pushStateInStorage('FacilitiesListComponent', this.state);
  }

  add() {
    this.facilitiesFormService.open().then(
      (response) => {
        this.loadData();
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  /**
   *
   * @param facility Facility object
   */
  edit(facility: Facility) {
    this.facilitiesFormService.open(facility);
  }

  /**
   *
   * @param facility Facility object
   */
  delete(facility: Facility) {
    this.facilityService.destroy(facility.id).subscribe(() => {
      this.loadData(this.state);
    });
  }

  clearFilters() {
    this.apiQuery = new ApiQuery();
    this.loadData();
  }
}
